import { AbstractCommand } from 'src/models/command';

class SaveTheMailDraftCommand extends AbstractCommand {
	readonly name = 'IFS_Mail_Command_Command_SaveTheMailDraftCommand';

	public constructor(
		draftName: string,
		draftId: string,
		autoSave: string,
		senderAccountId: number,
		managedSignatureId: number,
		subject: string,
		content: string,
		receiversTo: Array<string>,
		receiversCC: Array<string>,
		receiversBCC: Array<string>,
		attachmentIds: Array<string>,
		originalAttachmentIds: Array<string>,
		replyOrForwardMailAggregateId: string,
		replyOrForwardType: string
	) {
		super();
		this.parameters = {
			attachmentIds: attachmentIds,
			autoSave: autoSave,
			content: content,
			draftId: draftId,
			draftName: draftName,
			managedSignatureId: managedSignatureId,
			originalAttachmentIds: originalAttachmentIds,
			receiversBCC: receiversBCC,
			receiversCC: receiversCC,
			receiversTo: receiversTo,
			replyOrForwardMailAggregateId: replyOrForwardMailAggregateId,
			replyOrForwardType: replyOrForwardType,
			senderAccountId: senderAccountId,
			subject: subject,
		};
	}
}

export { SaveTheMailDraftCommand };
